import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    components: { DatePicker },
    data() {
        return {
            selectedOption: {
                name: '',
            },
            showMenu: false,
            placeholderText: 'Please select an item',
            datePicker: {
                lines: [
                    {id: 1, status: 1, date: 1}
                ],
                jsonData: [],
                defaultLines: [],
                firstDate: '',
                date: null,
                lastDate: '',

            }
        }
    },
    props: {
        options: {
            type: [[Array, Object]]
        },
        selected: {
            type: [Object]
        },
        placeholder: [String],
        closeOnOutsideClick: {
            type: [Boolean],
            default: true,
        },
        period: {
            type: Boolean,
            default: false
        },
        days: {
            type: Boolean,
            default: false
        },
        withDatePicker: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (!this.selected) {
            this.selectedOption = this.options[0];
        } else {
            this.selectedOption = this.selected
        }
        if (this.placeholder) {
            this.placeholderText = this.placeholder;
        }
        if (this.closeOnOutsideClick) {
            document.addEventListener('click', this.clickHandler);
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.clickHandler);
    },
    methods: {
        updateOption(option) {
            this.selectedOption = option;
            this.showMenu = false;
            this.$emit('updateOption', this.selectedOption);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        clickHandler(event) {           //click outside the element
            const {target} = event;
            const {$el} = this;
            if (!$el.contains(target)) {
                this.showMenu = false;
            }
        },
        defaultDate: function() {    // discharge date
            this.datePicker.lines = this.datePicker.jsonData
        },
        handleChange() {
            this.datePicker.defaultLines = this.datePicker.jsonData
            this.datePicker.firstDate = this.convertDate(this.datePicker.date[0])
            this.datePicker.lastDate = this.convertDate(this.datePicker.date[1])
            this.datePicker.lines = this.datePicker.defaultLines.filter(defaultLine => (defaultLine.created_at||'').split('T')[0] >= this.datePicker.firstDate && (defaultLine.created_at||'').split('T')[0] <= this.datePicker.lastDate)

            // console.log(this.datePicker);
            let prepareDateRange = {
                pluck: {
                    start: this.datePicker.firstDate,
                    end: this.datePicker.lastDate,
                }
            };
            this.$emit('updateOption', prepareDateRange);

            let dateStart = new Date(this.datePicker.firstDate);
            let dateEnd = new Date(this.datePicker.lastDate);

            this.selectedOption = {
                id: ((Array.isArray(this.options)) ? this.options.length : Object.keys(this.options).length ) + 1,
                name: dateStart.toDateString() + ' ~ ' + dateEnd.toDateString()
            };

            this.showMenu = !this.showMenu;
        },
        convertDate: function(arg) { //convert date to MM-DD-YYYY format
            return arg.getFullYear() + '-' +
                (arg.getMonth()<10?'0':'') +
                (arg.getMonth()+1) + '-' +
                (arg.getDate()<10?'0':'')+
                arg.getDate()
        }
    }
}
